export function wave_blob({compId,shapeHeight,animationSpeed,flipAnimation}) {
  return `
  <pattern class="patternRepeat" id="pat_${compId}" patternUnits="userSpaceOnUse" height="${shapeHeight}" viewbox="0 0 1920 240" x="50%" y="0" preserveAspectRatio="none" width="${shapeHeight*16}" patternTransform="translate(960 0)">
   <path d="">
   <animate attributeType="xml" attributeName="d"
   values="M 0 120 C 0 120 0 120 0 120 C 10 120 10 120 10 120 C 66.1 120 142.1 16 234.6 16 C 337.8 16 384 201.1 459.4 218.3 C 565.2 242.4 707.9 34.8 789.9 105.9 C 939.3 235.5 939.3 22.6 1037.1 22.6 C 1144.2 22.6 1175.4 214.5 1316 137.6 C 1444.2 67.5 1506.3 228.8 1581.7 214.3 C 1625.6 205.9 1633.1 16 1727.1 16 C 1806.4 16 1867 120 1919.9 120 C 1938 120 1919.9 240 1919.9 240 H 0 V 120 Z;M 0 120 C 0 120 0 120 0 120 C 66.1 120 142.1 16 234.6 16 C 337.8 16 384 201.1 459.4 218.3 C 565.2 242.4 707.9 34.8 789.9 105.9 C 939.3 235.5 939.3 22.6 1037.1 22.6 C 1144.2 22.6 1175.4 214.5 1316 137.6 C 1444.2 67.5 1506.3 228.8 1581.7 214.3 C 1625.6 205.9 1633.1 16 1727.1 16 C 1806.4 16 1867 120 1919.9 120 C 1920 120 1920 120 1919.9 120 C 1938 120 1919.9 240 1919.9 240 H 0 V 120 Z
       "
   keyTimes="0;1" calcMode="spline"
   keySplines="0 0 1 1"
    dur="${10 * animationSpeed}s" repeatCount="indefinite" fill="freeze"/>
   </path>
  </pattern>
<mask id="mask_${compId}">
  <rect class="animdiv-mask animdiv-mask-top" width="100%" height="${shapeHeight}" fill="url(#pat_${compId})"></rect>
</mask>
<mask class="flipped" id="mask_single_${compId}">
  <rect class="animdiv-mask animdiv-mask-top" x="50%" width="1920" height="${shapeHeight}" fill="url(#single_${compId})"></rect>
</mask>
`;
}